import {
  ISeasonalPVCharge,
  ITouPeriods,
  ITouRate,
} from './algorithm/algoInterface'

export const INIT_TOU_RATE: ITouRate = {
  spr: {
    minMid: 0,
    minMax: 0,
  },
  sum: {
    minMid: 0,
    minMax: 0,
  },
  fall: {
    minMid: 0,
    minMax: 0,
  },
  win: {
    minMid: 0,
    minMax: 0,
  },
}

export const INIT_TIME_DATA_ITEM = {
  date: '2023-01-01T00:00:00',
  value: 0,
}

export const INIT_SEASONAL_PV_CHARGE: ISeasonalPVCharge = {
  spr: {
    pv: 0,
    charge: 0,
  },
  sum: {
    pv: 0,
    charge: 0,
  },
  fall: {
    pv: 0,
    charge: 0,
  },
  win: {
    pv: 0,
    charge: 0,
  },
}

export const INIT_KEPCO_TOU_PERIODS: ITouPeriods = {
  spr: {
    week: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid',
      'mid',
      'mid',
      'max',
      'mid',
      'max',
      'max',
      'max',
      'max',
      'max',
      'mid',
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    sat: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    holi: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
  },
  sum: {
    week: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid',
      'mid',
      'mid',
      'max',
      'mid',
      'max',
      'max',
      'max',
      'max',
      'max',
      'mid',
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    sat: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    holi: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
  },
  fall: {
    week: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid',
      'mid',
      'mid',
      'max',
      'mid',
      'max',
      'max',
      'max',
      'max',
      'max',
      'mid',
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    sat: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    holi: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
  },
  win: {
    week: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid',
      'max',
      'max',
      'max',
      'mid',
      'mid',
      'mid',
      'mid',
      'max',
      'max',
      'max',
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    sat: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'mid',
      'min',
      'min',
    ],
    holi: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
  },
}

export const INIT_SINGLE_TOU_PERIODS: ITouPeriods = {
  spr: {
    week: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
    sat: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
    holi: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
  },
  sum: {
    week: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
    sat: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
    holi: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
  },
  fall: {
    week: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
    sat: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
    holi: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
  },
  win: {
    week: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
    sat: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
    holi: [
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
      'min',
    ],
  },
}
